module.exports = __webpack_public_path__ + "img/fig02.3ba8880f.jpg";